module.exports = {"330127100":"千岛湖镇","330127101":"文昌镇","330127102":"石林镇","330127103":"临岐镇","330127104":"威坪镇","330127106":"姜家镇","330127107":"梓桐镇","330127108":"汾口镇","330127109":"中洲镇","330127110":"大墅镇","330127111":"枫树岭镇","330127200":"里商乡","330127201":"金峰乡","330127202":"富文乡","330127203":"左口乡","330127205":"屏门乡","330127206":"瑶山乡","330127208":"王阜乡","330127210":"宋村乡","330127211":"鸠坑乡","330127212":"浪川乡","330127214":"界首乡","330127216":"安阳乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330127.json
// module id = 875
// module chunks = 0